import React from "react";
import { MapContainer, TileLayer, Marker } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import "./AdDetailsMap.css";

// fix default marker icon paths (needed if you get broken marker icons)
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

const AdMap = ({ latitude, longitude, zoom = 13 }) => {
    // fallback to center of Slovenia if coords missing
    const position = [
        latitude ?? 46.056946,
        longitude ?? 14.505751
    ];

    return (
        <div className="item_map">
            <h5 className="item_map_title">⁍ Lokacija</h5>
            <MapContainer
                center={position}
                zoom={zoom}
                scrollWheelZoom={false}
                style={{ height: '200px', width: '100%', borderRadius: '8px' }}
            >
                {/* OSM tiles (no API key needed) */}
                <TileLayer
                    attribution='&copy; <a href="https://osm.org/copyright">OpenStreetMap</a>'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                <Marker position={position}>
                </Marker>
            </MapContainer>
        </div>
    );
};

export default AdMap;